module.exports = __webpack_public_path__ + "img/home-icon.1ef06868.png";